import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';


@Component({
  selector: 'shared-client-name',
  standalone: true,
  imports: [],
  templateUrl: './client-name.component.html',
  styleUrl: './client-name.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientNameComponent {
  name = input.required<string>();
}
